// extracted by mini-css-extract-plugin
module.exports = {"BannerWelcome":"Banner_BannerWelcome__2i4rF","BannerWelcomeContainer":"Banner_BannerWelcomeContainer__1Znlw","ButtonOutlinedWhite":"Banner_ButtonOutlinedWhite__mSHsz"};